import type { ScenarioContent } from '../types';
import { hospitalityScenarios } from './hospitality';
import { venueScenarios } from './venues';

/** All business scenario pages, in navigation order. */
export const businessScenarios: ScenarioContent[] = [...hospitalityScenarios, ...venueScenarios];

export const BUSINESS_SCENARIO_SLUGS: string[] = businessScenarios.map((scenario) => scenario.slug);

export const BUSINESS_SCENARIO_PATHS: string[] = BUSINESS_SCENARIO_SLUGS.map((slug) => `/business/${slug}`);

export function getScenario(slug: string | undefined): ScenarioContent | undefined {
  return businessScenarios.find((scenario) => scenario.slug === slug);
}
